const modal = (): void => {
  const inlineModalTriggers = document.querySelectorAll<HTMLElement>('a');

  inlineModalTriggers.forEach((trigger) => {
    const triggerContent = trigger.textContent;
    const isModalTrigger = triggerContent.includes('[open-modal:');

    if (isModalTrigger) {
      const matches = triggerContent.match(/\[(.*?)\]/);
      const triggerTitle = triggerContent.replace(/\[(.*?)\]/, '');
      const triggerTarget = matches[1].replace('open-modal:', '');

      const modal = document.querySelector(
        '[data-modal="' + triggerTarget + '"]'
      );
      const modalVideos = modal?.querySelectorAll<HTMLVideoElement>('video');

      trigger.innerHTML = triggerTitle;
      trigger.setAttribute('data-modal-target', triggerTarget);

      trigger.addEventListener('click', () => {
        if (modal) {
          document.body.classList.toggle('body--modal-open');
          document.body.classList.toggle('modal-' + triggerTarget + '--open');

          if (modal.classList.contains('modal--open')) {
            modal.classList.remove('modal--open');

            modalVideos.forEach((video) => {
              video.pause();
            });
          } else {
            modal.classList.add('modal--open');
          }
        }
      });
    }
  });

  const modalOverlays = document.querySelectorAll('[data-modal-overlay]');
  modalOverlays.forEach((overlay) => {
    overlay.addEventListener('click', () => {
      const target = overlay.getAttribute('data-modal-overlay');

      const modal = document.querySelector('[data-modal="' + target + '"]');
      const modalVideos = modal?.querySelectorAll<HTMLVideoElement>('video');

      if (target) {
        document.body.classList.remove('body--modal-open');
        document.body.classList.remove('modal-' + target + '--open');
        modal.classList.remove('modal--open');
        modalVideos.forEach((video) => {
          video.pause();
        });
      }
    });
  });
};

export default modal;
